@if (isAuthenticated()) {
  <div class="col-xs-12 col-sm-10 col-xl-9 col-sm-offset-1 col-md-offset-2 pt-3 mx-auto">
    <br>
      <div class="row justify-content-between">
        <div class="col-xl-6 col-sm-12 row justify-content-start">
          <div class="mt-2 ms-0">
            <h2 style="line-height: 1.3em">Welcome {{ this.lS.uname }},</h2>
          </div>
          @if (this.lS.season!==null) {
            <h2>      
              <mat-form-field class="season">
                <mat-select [(ngModel)]="this.lS.season" (keydown.tab)="onSeasonSelected()">
                  @for (season of this.lS.seasons; track season) {
                    <mat-option (click)="onSeasonSelected()" [value]="season.season">{{ season.season }} Season</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </h2>
            }
            <br>
          </div>
          @if (isAuthenticated('mod-currency') && (this.cS.overviewStore?.fx!==null || this.cS.overviewStore?.fx12month!==null)) {
            <div class="col-xl-6 col-sm-12 row justify-content-start" style="text-align: right">
              @if (this.cS.overviewStore?.fx!==null) {
                <div class="col-6">
                  <p class="mt-2 mb-0" style="font-weight: 600">Day Average</p><p class="mb-2 mt-0" style="font-weight: 600">ZAR/USD</p>
                  <h2 class="mt-2 mb-2" style="font-weight: 500; color: green">{{ this.cS.overviewStore?.fx | number:'1.2-2' }}</h2>
                  <p>{{ this.cS.overviewStore?.fxdate | date:'EEE, MMM d, yyyy' }}</p>
                </div>
              }
              @if (this.cS.overviewStore?.fx12month!==null) {
                <div class="col-6">
                  <p class="mt-2 mb-0" style="font-weight: 600">12 Month Avg</p><p class="mb-2 mt-0" style="font-weight: 600">ZAR/USD</p>
                  <h2 class="mt-2 mb-2" style="font-weight: 500; color: blue">{{ this.cS.overviewStore?.fx12month | number:'1.2-2' }}</h2>
                  <p>{{ this.cS.overviewStore?.fx12monthdate | date:'EEE, MMM d, yyyy' }}</p>
                </div>
              }
              <div class="col">
                <p class="text-right">Source: Bloomberg</p>
              </div>
            </div>
          }
        </div>
        <br>
          <app-announcement></app-announcement>
          <app-article></app-article>
        </div>
      }

      @if (!isAuthenticated()) {
        <div class="col-xs-12 col-sm-10 col-md-7 col-sm-offset-1 col-md-offset-2 pt-3 mx-auto">
          <app-login></app-login>
        </div>
      }